import React from "react";
import img2 from "../../images/topicHomeDesktop.png";
import linesIcon from "../../images/linesIcon.png";
import refereshIcon from "../../images/refereshIcon.png";
import filterIcon from "../../images/filterIcon.png";

const TopicSection = () => {
    return(
        <div className="topic-section">
        <div className="topic-section-box topic-section-text">
          <h1 className="topic-section-heading">
          All of the info you want – none of the details you don’t.
          </h1>
          <div className="topic-blue-line"></div>
          <p className="topic-section-para">
            We have all of the latest information on how to diagnosis, treat and
            follow-up on conditions or clinical signs. The information is
            well-structured and synthesized.
          </p>
          {/* <button type="button" className="button topic-preview-button topic-preview-button-desktop">
            Preview Topic Pages
          </button> */}
          <div className="topic-feature-box">
            <span className="topic-feature-icon">
            <img src={linesIcon} alt="" />
            </span>
            <div className="topic-feature-text">
              <p className="topic-feature-heading">Comprehensive, but synthesized</p>
              <p className="topic-feature-para">
                Molestias excepturi sint occaecati cupiditate non provident,
                similique sunt.
              </p>
            </div>
          </div>
          <div className="topic-feature-box">
            <span className="topic-feature-icon">
            <img src={refereshIcon} alt="" />
            </span>
            <div className="topic-feature-text">
              <p className="topic-feature-heading">Keep Recirculating</p>
              <p className="topic-feature-para">
                Molestias excepturi sint occaecati cupiditate non provident,
                similique sunt.
              </p>
            </div>
          </div>
          <div className="topic-feature-box">
            <span className="topic-feature-icon">
            <img src={filterIcon} alt="" />
            </span>
            <div className="topic-feature-text">
              <p className="topic-feature-heading">Filter by Species</p>
              <p className="topic-feature-para">
                Molestias excepturi sint occaecati cupiditate non provident,
                similique sunt.
              </p>
            </div>
          </div>
        </div>
        <div className="topic-section-box topic-section-img">
          <img src={img2} alt="" />
          {/* <button type="button" className="button topic-preview-button topic-preview-button-mob">
          Preview Topic Pages
          </button> */}
        </div>
      </div>
    )
}
export default TopicSection;